import { NavLink } from "react-router-dom";
import styles from "./LinkWithSVG.module.css";

interface LinkProps {
  children: React.ReactNode;
  additional?: React.ReactNode;
  path: string;
  svg: React.ReactElement;
  className?: string;
  click: (el: HTMLAnchorElement, e: React.MouseEvent) => void;
}

export default function LinkWithSVG({ children, path, svg, className = "", additional, click }: LinkProps) {
  return (
    <NavLink
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        click(e.currentTarget, e);
      }}
      className={({ isActive }) => {
        return `${styles.link} ${isActive ? styles.active : ""} ${className}`.trim();
      }}
      to={path}
    >
      {svg}
      <span className={styles.label}>{children}</span>
      {additional}
    </NavLink>
  );
}
